import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// import $ from "jquery";

import CreateSaq from "../../components/CreateSaq";
// import CompletedSaqs from "../../components/CompletedSaqs";

import { images } from "../../helpers/images";

// import logo from "../../static/images/tg-logo.svg";

import { callApiSaqsFind, callApiUpdateUserPassword } from "../../services";
import { authUserData } from "../../helpers";
import SaqLists from "../../components/SaqLists";
import Header from "../../components/Header";

/* var openModalButton = document.getElementById("openModal");
var closeModalButton = document.getElementsByClassName("closeModal");

var modalSection = document.getElementById("saq-modal"); */

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      draftSaqData: null,
      completedSaqData: null,
      showModal: false,
    };
  }

  componentDidMount = async () => {
    const userData = authUserData();

    if (
      userData &&
      userData.accessToken &&
      userData.userType &&
      (userData.userType === "admin" ||
        userData.userType === "white-label-admin" ||
        userData.userType === "business-admin")
    ) {
      this.props.history.push("/control-panel");
    }

    // console.log("useData Dashboard", userData.userId);

    /* const tempPassword = await this.makeTempPassword();
    const userId = userData && userData.userId;
    callApiUpdateUserPassword(userId, { password: tempPassword }).then(
      (resData) => {
        
      }
    ); */

    callApiSaqsFind({ userId: userData.userId })
      .then((res) => {
        // console.log("api res", res);
        if (res.success && res.data && res.data.length > 0) {
          const draftList = res.data.filter((v, i) => {
            return v.status === "draft";
          });

          const completedList = res.data.filter((v, i) => {
            return v.status === "completed";
          });

          // console.log("completedList", completedList);

          this.setState({
            draftSaqData: draftList,
            completedSaqData: completedList,
          });
        }
      })
      .catch((error) => {
        // console.log("Dashboard fetch saq data ... error", error);
      });
  };

  makeTempPassword(length) {
    var result = [];
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$%^&*()-=";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result.push(
        characters.charAt(Math.floor(Math.random() * charactersLength))
      );
    }
    return result.join("");
  }

  onShowModal = () => {
    this.setState({ showModal: true });
  };

  onCloseModal = () => {
    console.log("closing Modal!");
    this.setState({ showModal: false });
  };

  render() {
    const { history } = this.props;
    const { draftSaqData, completedSaqData, showModal } = this.state;

    return (
      <div className="cell small-12 medium-10" id="maincontent">
        <Header />

        <ToastContainer />
        <div id="body-content">
          <div className="grid-x  grid-margin-x grid-margin-y">
            <div id="notification" className="cell small-12 medium-12">
              <div id="notification-content">
                <h3>Create New SAQ - Self Assesment Questionnaire</h3>
                <p>If you are not sure which SAQ to take click saq wizard.</p>
              </div>
              <Link to="/create/wizard" className="button create-button">
                SAQ Wizard <span id="plus-icn"></span>
              </Link>
            </div>
          </div>

          <div id="button-link" className="grid-x  grid-margin-x grid-margin-y">
            <div className="cell small-12 medium-12">
              <div className="grid-x grid-margin-x  small-up-12 medium-up-4">
                <div className="cell link-saq current" id="link-saq-a">
                  <Link to="/create/saq-a">
                    <span className="txt-small">CREATE New</span>
                    SAQ-A
                  </Link>
                </div>

                <div className="cell link-saq" id="link-saq-aep">
                  <Link to="/create/saq-a-ep">
                    <span className="txt-small">CREATE New</span>
                    SAQ A-EP
                  </Link>
                </div>

                <div className="cell link-saq" id="link-saq-b">
                  <Link to="/create/saq-b">
                    <span className="txt-small">CREATE New</span>
                    SAQ B
                  </Link>
                </div>

                <div className="cell link-saq" id="link-saq-a">
                  <Link to="/create/saq-b-ip">
                    <span className="txt-small">CREATE New</span>
                    SAQ B-IP
                  </Link>
                </div>
              </div>
            </div>
            <div className="cell small-12 medium-12">
              <div className="grid-x grid-margin-x small-up-12 medium-up-4">
                <div className="cell link-saq" id="link-saq-c">
                  <Link to="/create/saq-c">
                    <span className="txt-small">CREATE New</span>
                    SAQ-C
                  </Link>
                </div>

                <div className="cell link-saq" id="link-saq-dme">
                  <Link to="/create/saq-d-me">
                    <span className="txt-small">CREATE New</span>
                    SAQ D-ME
                  </Link>
                </div>

                <div className="cell link-saq" id="link-saq-dsp">
                  <Link to="/create/saq-d-sp">
                    <span className="txt-small">CREATE New</span>
                    SAQ D-SP
                  </Link>
                </div>

                <div className="cell link-saq saqwizard" id="link-saq-bip">
                  <Link to="/create/wizard">
                    <img src={images.wizard} />
                    SAQ WIZARD
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
